import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  MENU_ITEM__FORMS__RETURNED,
} from '../../constants';

const AdditionalFormFields = ({ form, selectedMenuItem }) => {
  const {
    approvalDate,
    assignedToExternalOrganizationDate,
    creationDate,
    receivedFromExternalOrganizationDate,
    returnedToExternalOrganizationDate,
    returnDescription,
  } = form;

  const additionalFields = [];
  let descriptionField = null;

  if (approvalDate) {
    additionalFields.push({ name: 'Data zatwierdzenia', value: approvalDate });
  }

  if (assignedToExternalOrganizationDate) {
    additionalFields.push({ name: 'Data przypisania do portalu', value: assignedToExternalOrganizationDate });
  }

  if (creationDate) {
    additionalFields.push({ name: 'Data utworzenia', value: creationDate });
  }

  if (receivedFromExternalOrganizationDate) {
    additionalFields.push({ name: 'Data przesłania z portalu', value: receivedFromExternalOrganizationDate });
  }

  if (returnedToExternalOrganizationDate) {
    additionalFields.push({ name: 'Data zwortu do portalu', value: returnedToExternalOrganizationDate });
  }

  if (returnDescription && selectedMenuItem === MENU_ITEM__FORMS__RETURNED) {
    descriptionField = returnDescription;
  }

  if (additionalFields.length === 0 && !descriptionField) {
    return null;
  }

  return (
    <div className="additional-form-fields">
      <For each="additionalField" index="id" of={additionalFields}>
        <div key={id} className="additional-field">
          {`${additionalField.name}: ${moment(additionalField.value).format('DD-MM-YYYY HH:mm')}`}
        </div>
      </For>
      <If condition={descriptionField}>
        <div className="description-field">
          {`Przyczyna zwrotu: ${descriptionField}`}
        </div>
      </If>
    </div>
  );
};

AdditionalFormFields.propTypes = {
  /** Formularz. */
  form: PropTypes.shape().isRequired,
  selectedMenuItem: PropTypes.string.isRequired,
};

AdditionalFormFields.defaultProps = {};

export default AdditionalFormFields;
